// extracted by mini-css-extract-plugin
export var modal = "_tq-0";
export var table = "_tq-1";